import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderOverviewReport = (apiData) => async (dispatch) => {
  try {
    const normalizeStatus = (status) => {
      if (typeof status !== "string") {
        return undefined;
      }

      const trimmed = status.trim();

      if (!trimmed) {
        return undefined;
      }

      return trimmed.replace(/\s+/g, "_");
    };

    const normalizeProviderOrgIds = (input) => {
      if (!Array.isArray(input)) {
        return [];
      }

      return input
        .map((item) => {
          if (item && typeof item === "object") {
            const candidate =
              item.provider_org_id ?? item.organisation_id ?? item.id ?? null;

            if (candidate !== null && candidate !== undefined) {
              return candidate;
            }
          }

          const parsed = Number(item);
          return Number.isFinite(parsed) ? parsed : null;
        })
        .filter((value) => value !== null && value !== undefined);
    };

    const normalizeClientOrgIds = (input) => {
      if (!Array.isArray(input)) {
        return [];
      }

      return input
        .map((item) => {
          if (item && typeof item === "object") {
            const candidate =
              item.organisation_id ?? item.client_org_id ?? item.id ?? null;

            if (candidate !== null && candidate !== undefined) {
              return candidate;
            }
          }

          const parsed = Number(item);
          return Number.isFinite(parsed) ? parsed : null;
        })
        .filter((value) => value !== null && value !== undefined);
    };

    const normalizeProviderTypeIds = (input) => {
      if (!Array.isArray(input)) {
        return [];
      }

      return input
        .map((item) => {
          if (item && typeof item === "object") {
            const candidate =
              item.provider_type_id ?? item.type_id ?? item.id ?? null;

            if (candidate !== null && candidate !== undefined) {
              return candidate;
            }
          }

          const parsed = Number(item);
          return Number.isFinite(parsed) ? parsed : null;
        })
        .filter((value) => value !== null && value !== undefined);
    };

    const normalizedStatus = normalizeStatus(apiData?.status);

    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/provider/GenerateProviderOverviewReport`,
      params: {
        ...apiData,
        ...(normalizedStatus !== undefined && { status: normalizedStatus }),
        client_org_ids: JSON.stringify(
          normalizeClientOrgIds(apiData?.client_org_ids)
        ),
        provider_org_ids: JSON.stringify(
          normalizeProviderOrgIds(apiData?.provider_org_ids)
        ),
        provider_type_ids: JSON.stringify(
          normalizeProviderTypeIds(apiData?.provider_type_ids)
        ),
        ...(apiData?.state_ids && { state_ids: JSON.stringify(apiData.state_ids) }),
        ...(apiData?.service_ids && { service_ids: JSON.stringify(apiData.service_ids) })
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
